import { Component } from '@angular/core';
import { IonicPage, LoadingController, ToastController, NavController, NavParams, reorderArray } from 'ionic-angular';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SERVER_URL } from "../../config";
import { tap } from 'rxjs/operators';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Storage } from "@ionic/storage";
import { AuthProvider } from "../../providers/auth/auth";
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { AddmenuPage } from '../addmenu/addmenu';
import { MenusceltePage } from '../menuscelte/menuscelte';
import { SlicePipe } from '@angular/common';
import { EditcategoriamenuPage } from '../editcategoriamenu/editcategoriamenu';

/**
 * Generated class for the MenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-menu',
  templateUrl: 'menu.html',
})
export class MenuPage {

  item;
  aut;
  menus: string[];
  errorMessage: string;
  link;
  categoriaMenuItem
  user;
  constructor(params: NavParams, private readonly loadingCtrl: LoadingController,
    private readonly httpClient: HttpClient,
    private readonly storage: Storage,
    authProvider: AuthProvider,
    public rest: RestApiProvider,
    public nav: NavController,
    public navParams: NavParams,
    public navCtrl: NavController,
  ) {
    this.categoriaMenuItem=navParams.get('categoriaMenu');

    this.link = SERVER_URL + "/manifesti/files/"

    this.item = params.data.item;
    this.aut = authProvider;
   
  }



  private handleResponse(resp: string) {
    console.log("RESP:" + resp);
    return " ";

  }
  openEditcategoriaMenuPage(){
    this.navCtrl.push(EditcategoriamenuPage, { categoriaMenu: this.categoriaMenuItem });
  
  }
  getMenus() {
    this.rest.getMenus(this.categoriaMenuItem)
      .subscribe(
        menus => this.menus = menus,
        error => this.errorMessage = <any>error);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MenuPage');
    this.getMenus();
    console.log("_________________________________________________this.categorie"+JSON.stringify(this.menus));
    this.storage.get('user').
    then((value) => {
      this.user = value;
      console.log(" constructor indirizzo STOREEEEEEEEEEEEEEEEEEEE:" + JSON.stringify(this.user))

    })
  }

  openMenuSceltePage(menu) {
    console.log("openArticoliPage:" + JSON.stringify(menu));

    this.nav.push(MenusceltePage, { menu: menu });


  }
  openAddMenuPage() {

    this.nav.push(AddmenuPage,{categoriaMenuItem:this.categoriaMenuItem});

  }
  reorderItems(indexes) {
    console.log("reorderItems:" + JSON.stringify(indexes));

    this.menus = reorderArray(this.menus, indexes);


    console.log("reorderItems list:" + JSON.stringify(this.menus));
    var i = 0;
    this.menus.forEach(function (element) {

      console.log(element["nome"]);
      element["visibilita"] = i;
      i++;
    });
    console.log("reorderItems list durante:" + JSON.stringify(this.menus));



    this.rest.aggiornaListMenu(this.menus);

  }


}



// WEBPACK FOOTER //
// ./src/pages/menu/menu.ts